<template>
  <Modal v-model="cancelOrderModal" :title="$t('key1004290')" width="700" :transfer="false" :mask-closable="false"
    class-name="cancelOrderModalStyle" @on-visible-change="cancelOrderChange">
    <Form ref="cancelOrderForm" :model="cancelOrderForm" :rules="ruleValidate" :label-width="100" @submit.native.prevent>
      <Row style="width: 98%;">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1004291')" prop="invalidReason">
            <Input v-model.trim="cancelOrderForm.invalidReason"
              :placeholder="$t('key1004287') + `${configCharacters()}` + $t('key1004289')"
              type="textarea" :rows="5">
            </Input>
          </Form-item>
        </Col>
      </Row>
      <template v-if="cancelPrice && payStatus !==1">
        <div>
          {{ $t('key1001077') }}
          <span class="themeColor ml3 mr4">{{ timer }}</span>
          {{ $t('key1001078') }}
          <span class="themeColor">{{ $t('key1001070') + cancelPrice + ' ' + currencyState }}</span>
          {{ $t('key1001079') }}
        </div>
        <div class="flex align-items-center mt15">
          <span class="themeColor">{{ $t('key1000233') }}</span>
          <span class="mr35">{{ formatCurrency(originalCost) + currencyState + '；' }}</span>
          <span class="redColor">{{ $t('key1000234') }}</span>
          <span>{{ formatCurrency(refundAmount) + ' ' + currencyState }}</span>
        </div>
      </template>
    </Form>
    <template #footer>
      <div style="text-align: right;">
        <Button @click="cancelOrderModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="cancelOrderBtn">{{ $t('key1004292') }}</Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {calculateDiffTime, getOrderLogisticsConsumption, setConfigCharacters} from "@/utils/common";

export default {
  name: 'cancelOrderModal',
  mixins: [Mixin],
  data() {
    return {
      cancelOrderModal: false,
      cancelOrderForm: {
        invalidReason: ''
      },
      ruleValidate: {
        invalidReason: [
          {required: true, message: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004287')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004288')}`, trigger: 'blur'}
        ]
      },
      ymsPackageId: null,
      originalCost: null,
      refundAmount: null,
      cancelPrice: 0,
      timer: null,
      payStatus: null
    };
  },
  methods: {
    // 初始化数据
    initCancelOrderData(ymsPackageId, obj) {
      this.ymsPackageId = ymsPackageId;
      this.originalCost = obj.totalPrice;
      this.payStatus = obj.payStatus || null;
      getOrderLogisticsConsumption(ymsPackageId).then((data) => {
        if (data) {
          this.cancelPrice = data.cancelPrice;
          this.refundAmount = this.originalCost - this.cancelPrice;
          let trackingNumberTime = obj.trackingNumberTime || '';
          if (trackingNumberTime) {
            trackingNumberTime = this.$uDate.dealTime(trackingNumberTime, 'fulltime');
            this.timer = calculateDiffTime(trackingNumberTime);
          }
        }
      });
      this.cancelOrderModal = true;
    },
    // 确认取消
    cancelOrderBtn() {
      let v = this;
      let query = {
        ymsPackageId: v.ymsPackageId,
        invalidReason: v.cancelOrderForm.invalidReason,
      };
      v.$refs['cancelOrderForm'].validate((valid) => {
        if (valid) {
          v.axios.post(api.post_ymsPackageInfo_cancelPackageInfo, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001067'));
              v.cancelOrderModal = false;
              v.$emit('cancelOrderSuccess', true);
            }
          });
        }
      });
    },
    // 监听弹窗
    cancelOrderChange(value) {
      let v = this;
      if (!value) {
        v.ymsPackageId = null;
        v.$nextTick(() => {
          v.$refs['cancelOrderForm'].resetFields();
          v.cancelPrice = 0;
          v.originalCost = null;
          v.timer = null;
          v.refundAmount = null;
          v.payStatus = null;
        });
      }
    }
  },
};
</script>

<style lang="less">

</style>
